
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';
import SanityReference from '~/components/Sanity/SanityReference.vue';

@Component({
  components: {
    SanityReference,
  },
})
export default class LiveStreamOverview extends Vue {
  @Prop(Object)
  readonly doc!: ISanityDocuments[SanityDocumentSchema.LIVE_STREAM];

  schemas = SanityDocumentSchema;

  get participants() {
    return this.doc?.castMembers || [];
  }

  get overview() {
    return this.doc?.overview || undefined;
  }
}
